import { findIndex } from 'lodash-es'

const getLeafNodes = (children) => children.flatMap(child => child.children ? getLeafNodes(child.children) : [child])

export class Survey {

    constructor(questionnaireCatalysts, respondentParameters) {
        this.themes = questionnaireCatalysts
        this.parameterOptionIdTitles = Object.fromEntries(
            respondentParameters
                .flatMap(p => getLeafNodes(p.children))
                .map(parameterOption => [parameterOption.value, parameterOption.label])
        )
    }

    getThemes() {
        return this.themes
    }

    getDrivers() {
        return this.themes.flatMap(t => t.drivers)
    }

    getLikertQuestions() {
        return this.themes.flatMap(t => t.questions)
    }

    getOpenQuestions() {
        return this.themes.flatMap(t => t.openQuestions)
    }

    getQuestionsByType(questionType) {
        if (questionType === 'likert') {
            return this.getLikertQuestions()
        } else if (questionType === 'open') {
            return this.getOpenQuestions()
        } else {
            throw new Error(`Assetion failed: unknown question type ${questionType}`)
        }
    }

    getTheme(themeId) {
        return this.themes.find(t => t.id === themeId)
    }

    getOpenQuestion(questionId) {
        return this.getOpenQuestions().find(q => q.id === questionId)
    }

    getThemeIdByDriverId(driverId) {
        return this.themes.find(t => t.drivers.find(d => d.id === driverId) !== undefined).id
    }

    getThemeIdByLikertQuestionId(questionId) {
        return this.themes.find(t => t.questions.find(q => q.id === questionId) !== undefined).id
    }

    getSurveyThemeIndex(themeId) {
        return findIndex(this.themes, t => t.id === themeId)
    }

    getRespondentGroups(questionId, questionType) {
        const question = this.getQuestionsByType(questionType).find(q => q.id === questionId)
        if (question.availability !== null) {
            return question.availability.acceptableParameterOptionIds
                .map(id => this.parameterOptionIdTitles[id])
                .filter(Boolean)
        } else {
            return undefined
        }
    }
}



// WEBPACK FOOTER //
// ./src/utilities/Survey.js